var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1320_568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.427 14.5001H13.1808C12.9708 14.4439 12.8167 14.3083 12.6665 14.1574C11.5091 12.9953 10.3484 11.8364 9.18846 10.6764C9.15705 10.645 9.12345 10.6154 9.09533 10.5887C9.08108 10.5917 9.0756 10.5913 9.07232 10.5935C9.05332 10.6059 9.0347 10.6191 9.01644 10.6322C7.68115 11.6055 6.20124 11.9526 4.57268 11.6588C2.39627 11.2661 0.586194 9.50988 0.136231 7.34668C0.0788897 7.07121 0.0449233 6.79099 0 6.51333C0 6.25795 0 6.00294 0 5.74756C0.00840029 5.70409 0.0168006 5.66025 0.0255661 5.61677C0.111395 5.19882 0.155223 4.76661 0.289993 4.3651C1.20891 1.6272 3.9401 0.0532991 6.76844 0.612277C10.2571 1.30205 12.2505 5.16922 10.7776 8.40764C10.5902 8.81902 10.3408 9.20226 10.1034 9.62899C10.1118 9.63556 10.1552 9.66187 10.1899 9.69658C10.8897 10.3951 11.5888 11.0944 12.2878 11.7937C12.7871 12.2931 13.2893 12.7896 13.7849 13.2927C14.1417 13.6551 14.0402 14.2316 13.5902 14.4355C13.5369 14.4596 13.4817 14.4786 13.4273 14.4998L13.427 14.5001ZM1.39591 6.11948C1.38714 8.44673 3.28378 10.3527 5.62162 10.3666C7.9485 10.3805 9.85939 8.48071 9.86925 6.1436C9.87911 3.8127 7.98247 1.9056 5.64573 1.89683C3.31739 1.88843 1.40468 3.78895 1.39627 6.11948H1.39591Z",
    fill: "#C2BFD1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1320_568"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.39971a7bd83ec41c8e985d2c20d1a661.svg";
export { ForwardRef as ReactComponent };